import React from "react";
import GuestPrizeRoll from "../../components/GuestPrizeRoll";

export default function GuestPrizeI() {
  return (
    <GuestPrizeRoll
      title="DOORPRIZE SESI I"
      prizeType="guest_prize_1"
      spinEndpoint="spinGuestPrize1Winner"
      winnerEndpoint="getGuestPrize1Winner"
      emptyMessage="Semua hadiah Doorprize Sesi I sudah keluar."
    />
  );
}
